import React from 'react'

function WhatWeDeal() {
    return (
        <div className="container-fluid">
            <div className="row pt-6">
                <div className="col-sm-12">
                    <h5 className="center green-text text-darken-1 ff-mono bold">WHAT WE DEAL</h5>
                </div>
                <div className="col-sm-12 pt-4 ">
                    <h1 className="center" style={{fontSize: '3.8rem'}}>
                        We’ve got everything you need to <br/> launch and grow your business
                    </h1>
                </div>
                <div className="col-sm-12 col-md-6 offset-md-3">
                    <div className="pt-4 mt-4" style={{borderBottom: '1px solid #d3d3d3'}}></div>
                </div>
            </div>
            <div className="container">
            <div className="row mt-5">
                    <div className="col-md-6 col-sm-12 mt-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-1 center">
                                <i className="fa fa-desktop green-text f-xxl"/>
                            </div>
                            <div className="col-sm-12 col-md-11">
                                <div className=" pl-4 row">
                                    <div className="col-12">
                                        <h3>Web Develepment</h3>
                                    </div>
                                    <div className="col-12">
                                        <p className="f-sm grey-text">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus voluptatem facilis quod modi cumque reprehenderit consectetur, accusantium sit cupiditate veniam labore dolorum hic et dolorem sunt ratione. Maiores, repellat expedita.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 mt-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-1 center">
                                <i className="fa fa-mobile green-text" style={{fontSize: '4rem', marginTop: '-10px'}}/>
                            </div>
                            <div className="col-sm-12 col-md-11">
                                <div className="pl-4 row">
                                    <div className="col-12">
                                        <h3>Android & iOS App Develepment</h3>
                                    </div>
                                    <div className="col-12">
                                        <p className="f-sm grey-text">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus voluptatem facilis quod modi cumque reprehenderit consectetur, accusantium sit cupiditate veniam labore dolorum hic et dolorem sunt ratione. Maiores, repellat expedita.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 mt-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-1 center">
                                <i className="fa fa-paint-brush green-text f-xxl"/>
                            </div>
                            <div className="col-sm-12 col-md-11">
                                <div className=" pl-4 row">
                                    <div className="col-12">
                                        <h3>Graphic Designing</h3>
                                    </div>
                                    <div className="col-12">
                                        <p className="f-sm grey-text">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus voluptatem facilis quod modi cumque reprehenderit consectetur, accusantium sit cupiditate veniam labore dolorum hic et dolorem sunt ratione. Maiores, repellat expedita.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 mt-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-1 center">
                                <i className="fa fa-database f-xxl green-text" />
                            </div>
                            <div className="col-sm-12 col-md-11">
                                <div className="pl-4 row">
                                    <div className="col-12">
                                        <h3>Data Science</h3>
                                    </div>
                                    <div className="col-12">
                                        <p className="f-sm grey-text">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus voluptatem facilis quod modi cumque reprehenderit consectetur, accusantium sit cupiditate veniam labore dolorum hic et dolorem sunt ratione. Maiores, repellat expedita.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-12 mt-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-1 center">
                                <i className="fa fa-user-plus f-xxl green-text"  />
                            </div>
                            <div className="col-sm-12 col-md-11">
                                <div className="pl-4 row">
                                    <div className="col-12">
                                        <h3>Marketing</h3>
                                    </div>
                                    <div className="col-12">
                                        <p className="f-sm grey-text">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus voluptatem facilis quod modi cumque reprehenderit consectetur, accusantium sit cupiditate veniam labore dolorum hic et dolorem sunt ratione. Maiores, repellat expedita.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-12 mt-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-1 center">
                                <i className="fa fa-slack f-xxl green-text pt-1" />
                            </div>
                            <div className="col-sm-12 col-md-11">
                                <div className="pl-4 row">
                                    <div className="col-12">
                                        <h3>Brand Identity</h3>
                                    </div>
                                    <div className="col-12">
                                        <p className="f-sm grey-text">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Delectus voluptatem facilis quod modi cumque reprehenderit consectetur, accusantium sit cupiditate veniam labore dolorum hic et dolorem sunt ratione. Maiores, repellat expedita.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="pt-5"></div>
            </div>
        </div>
    )
}

export default WhatWeDeal;